import { render, staticRenderFns } from "./headerPtenDeduplicate.vue?vue&type=template&id=6aaabcfb&scoped=true"
import script from "./headerPtenDeduplicate.vue?vue&type=script&lang=js"
export * from "./headerPtenDeduplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaabcfb",
  null
  
)

export default component.exports